import type {
  ApiRegisterUserJourneyEventParams,
  ApiRegisterUserJourneyEventPort,
} from '~/handlers/ports/api-register-user-journey-event.port';
import { cleanObject } from '~/utils/apostatudo/clean-object';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';
import { isRunningInNativeApp } from '~/utils/browserInfo';

const toApiPayload = (
  params: ApiRegisterUserJourneyEventParams,
): Record<string, unknown> => {
  // Choke point único: dentro do app, o payload do /collector nunca leva dados
  // de terceiros (Meta/Google/TikTok) nem device fingerprint — mesmo que o store
  // tenha resíduo de uma sessão anterior no navegador (ENG-397).
  const inApp = isRunningInNativeApp();

  const payload: Record<string, unknown> = { action: params.event };

  if (params.user?.id) payload.user_id = params.user.id;
  if (!inApp && params.device?.fingerprint)
    payload.device_fingerprint = params.device.fingerprint;
  if (typeof params.deposit_id === 'number')
    payload.deposit_id = params.deposit_id;
  if (params.slug) payload.slug = params.slug;
  if (params.home_menu_item_id)
    payload.home_menu_item_id = params.home_menu_item_id;
  if (typeof params.home_menu_item_rendered_position === 'number')
    payload.home_menu_item_rendered_position =
      params.home_menu_item_rendered_position;

  const utm = cleanObject(params.utm);

  if (utm) payload.utm = utm;

  const google = inApp ? null : cleanObject(params.google);

  if (google) payload.google = google;

  const facebook = inApp ? null : cleanObject(params.facebook);

  if (facebook) payload.facebook = facebook;

  const tiktok = inApp ? null : cleanObject(params.tiktok);

  if (tiktok) payload.tiktok = tiktok;

  const apt = cleanObject(params.apt);

  if (apt) payload.apt = apt;

  const appsflyer = cleanObject(params.appsflyer);

  if (appsflyer) payload.appsflyer = appsflyer;

  const appsflyerConversion = cleanObject(params.appsflyer_conversion);

  if (appsflyerConversion) payload.appsflyer_conversion = appsflyerConversion;

  return payload;
};

export class ApostatudoApiRegisterUserJourneyEventAdapter
  implements ApiRegisterUserJourneyEventPort
{
  async handle(params: ApiRegisterUserJourneyEventParams) {
    const response = await fetch(`${getApostatudoApiUrl()}/collector`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(toApiPayload(params)),
      keepalive: true,
    });

    if (!response.ok) {
      throw new Error(
        `[ApostatudoApiRegisterUserJourneyEventAdapter] APOSTATUDO API returned ${response.status}: ${response.statusText}`,
      );
    }
  }
}
